module.exports = require("@mui/icons-material/DeleteOutline");